/* istanbul ignore file */

export function isFiniteNumberString(s: string): boolean {
    if (s === '') return false;
    const n = Number(s);
    return Number.isFinite(n) && String(n) === s;
}
